import { Dialog } from "primereact/dialog";
import localeText from "../../../../locale";

// Diálogo de criação/edição usado pelos cadastros do novo admin
const FormDialog = ({
  visible,
  title,
  subtitle,
  saving = false,
  saveLabel,
  onSave,
  onCancel,
  width = "36rem",
  children,
}) => (
  <Dialog
    visible={visible}
    onHide={() => !saving && onCancel()}
    header={
      <div>
        <div className="admin-dialog__title">{title}</div>
        {subtitle && <div className="admin-dialog__subtitle">{subtitle}</div>}
      </div>
    }
    draggable={false}
    resizable={false}
    className="admin-dialog"
    style={{ width }}
    breakpoints={{ "640px": "calc(100vw - 1rem)" }}
    footer={
      <div className="admin-confirm__footer">
        <button type="button" className="admin-btn" onClick={onCancel} disabled={saving}>
          {localeText("cancel")}
        </button>
        <button
          type="button"
          className="admin-btn admin-btn--primary"
          onClick={onSave}
          disabled={saving}
        >
          {saving && <i className="pi pi-spin pi-spinner" aria-hidden="true" />}
          {saveLabel || localeText("adminFormSave")}
        </button>
      </div>
    }
  >
    <form
      className="admin-form"
      onSubmit={(e) => {
        e.preventDefault();
        if (!saving) onSave();
      }}
    >
      {children}
      {/* Enter em qualquer campo envia o formulário */}
      <button type="submit" hidden aria-hidden="true" tabIndex={-1} />
    </form>
  </Dialog>
);

export default FormDialog;
